import { useTranslation } from "react-i18next";
import React from "react";
import { deleteGlobalMessage } from "../../../../../../axios/api/services";
import useAppDispatch from "../../../../../../hooks/redux/base/useAppDispatch";
import { ConfirmDialog } from "@duosoftbg/nacid-components";
import useAppSelector from "../../../../../../hooks/redux/base/useAppSelector";
import { closeModal } from "../../../../../../store/redux/slice/ComponentsControl/globalMessageControl";
import { SEARCH_FILTERS_GROUP } from "../../../../../../config/search/filters/groupsConfig";
import { useFormContext } from "react-hook-form";
import { onDeleteTableEntrySuccess } from "../../../../../../utils/functions";

const DeleteGlobalMessageDialog = ({ filterFn, records, total }) => {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const { getValues, setValue } = useFormContext();
  const group = SEARCH_FILTERS_GROUP.GLOBAL_MESSAGE_MANAGEMENT;

  const { open, id } = useAppSelector((state) => {
    return state.ComponentsControl.globalMessageControl.modals.delete;
  });

  const handleCloseDialog = () => {
    dispatch(closeModal({ modalType: "delete" }));
  };

  const onSuccess = (response) => {
    onDeleteTableEntrySuccess(group, records.length, total, filterFn, dispatch, closeModal, getValues, setValue, t);
  };

  return (
    <ConfirmDialog
      open={open}
      onClose={handleCloseDialog}
      promiseFunction={() => deleteGlobalMessage(id)}
      onSuccess={onSuccess}
      title={"t.email.globalMessage.delete.dialog"}
      message={"m.delete.email.globalMessage.warning.message"}
    />
  );
};

export default DeleteGlobalMessageDialog;
